const CART_KEY = 'lumora_cart';
const WISHLIST_KEY = 'lumora_wishlist';
const CHECKOUT_KEY = 'lumora_checkout';
const NEWSLETTER_KEY = 'lumora_newsletter';

export const loadFromStorage = (key, fallback = null) => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : fallback;
  } catch {
    return fallback;
  }
};

export const saveToStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error('Storage save failed:', e);
  }
};

export const storageKeys = {
  cart: CART_KEY,
  wishlist: WISHLIST_KEY,
  checkout: CHECKOUT_KEY,
  newsletter: NEWSLETTER_KEY,
};
